import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import client from "../../client";
import handleApiError from "../../../hooks/handleApiError";

export default function useFetchArchivedStudents(session, type) {
  const { schoolId, category } = useParams();
  const [response, setResponse] = useState([]);
  const [loading, setLoading] = useState(false);

  const request = useCallback(
    async (_session) => {
      try {
        setResponse([]);
        setLoading(true);

        const { data } = await client.get(`/archives/archived-students`, {
          params: {
            school: schoolId,
            category:
              category === "junior"
                ? "JSS3"
                : category === "senior"
                ? "SSS3"
                : null,
            session: _session,
            endedSessionAs: type,
          },
        });

        setResponse(data?.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleApiError(error);
      }
    },
    [category, schoolId, type]
  );

  const reset = () => {
    setResponse([]);
  };

  useEffect(() => {
    if (session) {
      request(session);
    }
  }, [session, request]);

  return [response, loading, reset];
}
